export default __webpack_public_path__ + "static/media/gallery_04.a34396c2.jpg";